import {
  FileInputRenderer,
  type FileInputRendererProps,
  getRendererProps,
} from '@exam-center/components';
import { Flex, SectionTitle, Text } from '@shared/components';

export interface FileDocumentFieldsProps {
  fields: {
    evidenceFiles: FileInputRendererProps;
  };
}

export default function FileDocumentFields(props: Readonly<FileDocumentFieldsProps>) {
  const { fields } = props;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}>
      <SectionTitle title='File Document' />
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
          เอกสารสำคัญ
        </Text>
        <Flex
          sx={(theme) => ({ gap: theme.spacing(6), flexDirection: 'column', flexBasis: '600px' })}
        >
          <FileInputRenderer
            {...getRendererProps(fields.evidenceFiles, {
              label: 'เอกสารหลักฐานที่เกี่ยวข้อง',
              placeholder: 'กรุณาอัปโหลดไฟล์ .JPG หรือ .JPEG หรือ .PNG หรือ .PDF',
              required: true,
            })}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
